import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { ThemeProvider } from './uikit/ThemeProvider';
import { MainFormPage } from './pages/MainFormPage';
import { ReferralPage } from './pages/ReferralPage';
import { BaufiImmoScoutPage } from './pages/BaufiImmoScoutPage';
import './styles/global.css';
import { ENDPOINTS } from '../types/endpoints';
import { AppStartObserver } from './components/specific/AppStartObserver';
import { SwitchingPage } from './pages/SwitchingPage';
import { DrKleinPage } from './pages/DrKleinPage';
import { ImmoweltPage } from './pages/ImmoweltPage';
import { Baufi24Page } from './pages/Baufi24Page';
import { HypoFriendPage } from './pages/HypoFriendPage';
import { VergleichPage } from './pages/VergleichPage';
import { LogsMonitoringObserver } from './components/specific/LogsMonitoringObserver';
import { BugsnagErrorsTestPage } from './pages/TestPages/BugsnagErrorsTestPage';
import { MuiTestPage } from './pages/TestPages/MuiTestPage';
import { REFERRAL_TYPES } from './store/initialData/initialData.types';
import { useSelector } from 'react-redux';
import { initialDataSlice } from './store/initialData/initialData.slice';
import { FCLeadFormPage } from './pages/FCLeadFormPage';
import { FinanceAdsComparisonPage } from './pages/FinanceAdsComparisonPage';
var App = function () {
    var isMainFormAvailable = useSelector(initialDataSlice.selectors.getIsCustomerAbleReachOwnFlow);
    var redirect404Link = isMainFormAvailable
        ? ENDPOINTS.ROOT
        : ENDPOINTS.MORTGAGE_ROUTE_2;
    return (React.createElement(LogsMonitoringObserver, null,
        React.createElement(ThemeProvider, null,
            React.createElement(AppStartObserver, null),
            React.createElement(Routes, null,
                React.createElement(Route, { path: ENDPOINTS.ROOT, element: React.createElement(MainFormPage, null) }),
                React.createElement(Route, { path: ENDPOINTS.SWITCHING_PAGE, element: React.createElement(SwitchingPage, null) }),
                React.createElement(Route, { path: ENDPOINTS.MORTGAGE_ROUTE_2, element: React.createElement(BaufiImmoScoutPage, null) }),
                React.createElement(Route, { path: ENDPOINTS.MORTGAGE_ROUTE_3, element: React.createElement(FinanceAdsComparisonPage, null) }),
                React.createElement(Route, { path: ENDPOINTS.MORTGAGE_ROUTE_4, element: React.createElement(ImmoweltPage, null) }),
                React.createElement(Route, { path: ENDPOINTS.MORTGAGE_ROUTE_5, element: React.createElement(DrKleinPage, null) }),
                React.createElement(Route, { path: ENDPOINTS.MORTGAGE_ROUTE_6, element: React.createElement(Baufi24Page, null) }),
                React.createElement(Route, { path: ENDPOINTS.MORTGAGE_ROUTE_7, element: React.createElement(HypoFriendPage, null) }),
                React.createElement(Route, { path: ENDPOINTS.MORTGAGE_ROUTE_8, element: React.createElement(VergleichPage, null) }),
                React.createElement(Route, { path: ENDPOINTS.MORTGAGE_ROUTE_9, element: React.createElement(FCLeadFormPage, null) }),
                React.createElement(Route, { path: ENDPOINTS.REFERRAL_SCOPE },
                    React.createElement(Route, { path: "advisor/:referralIdUrlParam", element: React.createElement(ReferralPage, { type: REFERRAL_TYPES.ADVISOR }) }),
                    React.createElement(Route, { path: "external/:referralIdUrlParam", element: React.createElement(ReferralPage, { type: REFERRAL_TYPES.EXTERNAL }) }),
                    React.createElement(Route, { path: "employee/", element: React.createElement(ReferralPage, { type: REFERRAL_TYPES.EMPLOYEE, id: 'employee' }) })),
                React.createElement(Route, { path: "/test/errors/", element: React.createElement(BugsnagErrorsTestPage, null) }),
                React.createElement(Route, { path: "/test/mui/", element: React.createElement(MuiTestPage, null) }),
                React.createElement(Route, { path: "*", element: React.createElement(Navigate, { to: redirect404Link, replace: true }) })))));
};
export default App;
